import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { FormFields } from '@epi-forms/helpers';
import { ON_HOLD } from '@epi-constants/benefitTypes';
import { AdminTopupFormType } from '@epi-pages/LoadBenefit/components/AdminTopup/AdminTopupForm';
import { topupSliceActions } from '@epi-store/topup/topup.slice';

export const useAdminTopupFormContext = () => {
  const dispatch = useDispatch();

  const form = useForm<AdminTopupFormType>({
    mode: 'onChange',
    defaultValues: {
      [FormFields.MoneyAmount]: '',
      [FormFields.Page]: 1,
      [FormFields.CheckableEmployees]: []
    }
  });

  const { watch } = form;
  const checkableEmployees = watch(FormFields.CheckableEmployees);

  useEffect(() => {
    const isOnHoldEmployee = checkableEmployees.some(
      employee => employee.employmentType === ON_HOLD
    );

    if (isOnHoldEmployee) {
      dispatch(topupSliceActions.toggleShowTable(true));
    }
  }, [checkableEmployees]);

  useEffect(() => {
    return () => {
      dispatch(topupSliceActions.toggleShowTable(false));
    };
  }, []);

  return { form };
};
